var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/more_dots.e67ae570.png","uri@2x": __webpack_public_path__ + "static/media/more_dots.7a25a68b.png","uri@3x": __webpack_public_path__ + "static/media/more_dots.55001899.png",
    width: 4,
    height: 16
});